module.exports = __webpack_public_path__ + "static/media/options.e4a41a27.svg";